import React from 'react';

import { View } from 'react-native';
import { colors } from '@/constants/colors';

import BenchIcon from '@/components/Icons/Equipment/BenchIcon';
import ChairIcon from '@/components/Icons/Equipment/ChairIcon';
import DumbbellIcon from '@/components/Icons/Equipment/DumbbellIcon';
import FoamRollerIcon from '@/components/Icons/Equipment/FoamRollerIcon';
import GlidersIcon from '@/components/Icons/Equipment/GlidersIcon';
import KettlebellIcon from '@/components/Icons/Equipment/KettlebellIcon';
import MedicineBallIcon from '@/components/Icons/Equipment/MedicineBallIcon';
import MiniBandIcon from '@/components/Icons/Equipment/MiniBandIcon';
import ResistanceBandIcon from '@/components/Icons/Equipment/ResistanceBandIcon';
import ResistanceBandLowAnchorIcon from '@/components/Icons/Equipment/ResistanceBandLowAnchorIcon';
import StabilityBallIcon from '@/components/Icons/Equipment/StabilityBallIcon';
import StepIcon from '@/components/Icons/Equipment/StepIcon';

import EquipmentTypes from '@/constants/equipmentTypes';

interface IEquipmentIconProps {
  name?: EquipmentTypes;
  color?: string;
  width?: number;
}

const EquipmentIcon: React.FC<IEquipmentIconProps> = (props) => {
  const {
    name = EquipmentTypes.NONE,
    color = colors.white.secondary,
    width = 30,
  } = props;

  const getIconProps = (scale = 1) => {
    const size = width * scale;

    return {
      height: `${size}`,
      width: `${size}`,
      color,
    };
  };

  const getSelectedIcon = () => {
    switch (name) {
      case EquipmentTypes.DUMBBELLS:
        return <DumbbellIcon {...getIconProps()} />;
      case EquipmentTypes.BENCH:
        return <BenchIcon {...getIconProps()} />;
      case EquipmentTypes.STEP:
        return <StepIcon {...getIconProps()} />;
      case EquipmentTypes.STABILITY_BALL:
        return <StabilityBallIcon {...getIconProps()} />;
      case EquipmentTypes.MEDICINE_BALL:
        return <MedicineBallIcon {...getIconProps()} />;
      case EquipmentTypes.RESISTANCE_BAND:
        return <ResistanceBandIcon {...getIconProps()} />;
      case EquipmentTypes.KETTLEBELL:
        return <KettlebellIcon {...getIconProps()} />;
      case EquipmentTypes.RESISTANCE_BAND_LOW_ANCHOR:
        return <ResistanceBandLowAnchorIcon {...getIconProps()} />;
      case EquipmentTypes.CHAIR:
        return <ChairIcon {...getIconProps()} />;
      case EquipmentTypes.FOAM_ROLLER:
        return <FoamRollerIcon {...getIconProps()} />;
      case EquipmentTypes.MINI_BANDS:
        return <MiniBandIcon {...getIconProps()} />;
      case EquipmentTypes.GLIDERS:
        return <GlidersIcon {...getIconProps()} />;
      default:
        return (
          <View
            style={{
              flexDirection: 'row',
              width: width * 4.5,
              justifyContent: 'space-between',
              height: '100%',
              alignItems: 'center',
            }}
          >
            <DumbbellIcon {...getIconProps(0.85)} />
            <BenchIcon {...getIconProps(0.8)} />
            <StepIcon {...getIconProps(0.8)} />
            <StabilityBallIcon {...getIconProps(0.8)} />
            <MedicineBallIcon {...getIconProps(0.8)} />
            <ResistanceBandIcon {...getIconProps(0.8)} />
            <KettlebellIcon {...getIconProps(0.8)} />
            <ResistanceBandLowAnchorIcon {...getIconProps(0.8)} />
            <ChairIcon {...getIconProps(0.8)} />
            <FoamRollerIcon {...getIconProps(0.8)} />
            <MiniBandIcon {...getIconProps(0.8)} />
            <GlidersIcon {...getIconProps(0.8)} />
          </View>
        );
    }
  };

  return getSelectedIcon();
};

export default EquipmentIcon;
